import React from "react";

import "./Header.css";
import {Col, Row} from "antd";

const BoxFooter = (props) => {
    return (
      <footer className="box-footing">
        <Row type="flex" justify="end" align="middle" gutter={16} style={{ width: '100%' }} >
          {React.Children.map(props.children, child=> child && <Col span={child.props.span || 6}>{child}</Col>)}
        </Row>
      </footer>
    );
  }

export default BoxFooter
